export default {
  product: {
    title: '製品登録',
    product: '製品',
    newProduct: '新規製品',
    addProduct: '製品を追加',

    form: {
      producer: '生産者',
      productName: '製品名',
      productDescription: '製品説明（英語、500文字以内）',
      productVisual: '製品画像',
      productVisualInfo:
        '製品ビジュアル：紹介する製品のボトル画像を添付してください',
      productInfo: {
        title: '製品情報',
        productType: '製品タイプ',
        vineType: 'ワインの種類',
        color: '色',
        region: '地域',
        classification: '格付け',
        appellation: 'AOC/AOP 原産地呼称',
        denominationIgp: 'IGP 呼称',
        denomination: 'その他の呼称：VDF／その他のワイン／スピリッツ',
        typeCulture: '栽培方法',
        millesime: 'ヴィンテージ',
        newMillesime: '新しいヴィンテージ',
        cepage: 'ブドウ品種（複数選択可）',
        format: '容量',
        price: '価格帯',
        alcool: 'アルコール度数',
        typeVendange: '収穫方法',
        allergene: 'アレルゲン',
        arome: 'テイスティングフレーバー',
        technicalFile: '技術資料',
        new_milesime: '新しいヴィンテージ',
      },
      success: '製品を登録しました',
      save: '保存',
      cancel: 'キャンセル',
      confirm: '確認',
      confirmRemoveProduct: '製品を削除しますか？',
      remove: '削除',
      no_events_available: '利用可能なイベントがありません',
    },
  },
};
